import { NavLink, ThemeIcon } from '@mantine/core';
import { IconCalendarDue } from '@tabler/icons';
import { AppRoutePaths } from '../../../utils/enums/routes';

interface WorkScaleLinkProps {
  navigate(route: string): void;
}

export function WorkScaleLink({ navigate }: WorkScaleLinkProps) {
  return (
    <NavLink
      styles={{
        label: {
          color: '#373A40',
        },
      }}
      label="Escala"
      fw="bold"
      color=""
      icon={
        <ThemeIcon color="red" variant="light">
          <IconCalendarDue size={16} />
        </ThemeIcon>
      }
      childrenOffset={28}
    >
      <NavLink
        label="Lista"
        onClick={() => navigate(AppRoutePaths.WORK_SCALE_LIST)}
      />
      <NavLink
        label="Cadastro"
        onClick={() => navigate(AppRoutePaths.WORK_SCALE_CREATE)}
      />
    </NavLink>
  );
}
